<template>
  <div class="token-debug">
    <el-card>
      <div slot="header">
        <span>Token 调试信息</span>
      </div>
      <div class="debug-info">
        <h4>当前Token状态：</h4>
        <p><strong>localStorage中的原始值：</strong> {{ rawToken }}</p>
        <p><strong>tokenStorage.getToken()：</strong> {{ cleanToken }}</p>
        <p><strong>tokenStorage.hasToken()：</strong> {{ hasToken }}</p>
        <p><strong>Token长度：</strong> {{ tokenLength }}</p>
        
        <h4>操作：</h4>
        <el-button @click="refreshTokenInfo">刷新Token信息</el-button>
        <el-button @click="clearToken" type="danger">清除Token</el-button>
        <el-button @click="testRequest" type="primary">测试API请求</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { tokenStorage } from '@/utils/storage'
import { authApi } from '@/api'

export default {
  name: 'TokenDebug',
  data() {
    return {
      rawToken: '',
      cleanToken: '',
      hasToken: false,
      tokenLength: 0
    }
  },
  mounted() {
    this.refreshTokenInfo()
  },
  methods: {
    refreshTokenInfo() {
      this.rawToken = localStorage.getItem('Authorization') || '无'
      this.cleanToken = tokenStorage.getToken()
      this.hasToken = tokenStorage.hasToken()
      this.tokenLength = this.cleanToken ? this.cleanToken.length : 0
    },
    clearToken() {
      tokenStorage.removeToken()
      this.refreshTokenInfo()
      this.$message.success('Token已清除')
    },
    async testRequest() {
      try {
        const response = await authApi.getUserInfo()
        this.$message.success('API请求成功')
        console.log('测试请求响应:', response)
      } catch (error) {
        this.$message.error('API请求失败: ' + error.message)
        console.error('测试请求错误:', error)
      }
    }
  }
}
</script>

<style scoped>
.token-debug {
  margin: 20px;
}

.debug-info p {
  margin: 10px 0;
  word-break: break-all;
}

.debug-info h4 {
  margin-top: 20px;
  margin-bottom: 10px;
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/components/TokenDebug.vue